import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';
import { message } from 'antd';
import moment from 'moment';
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';

import compraEstablecimientoService from '../../../service/logistica/compraEstablecimientoService';
import monedaService from '../../../service/administracion/monedaService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from "../../../service/administracion/almacenService";

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            establecimientos: [],
            monedas: [],
            almacenes: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idMoneda: 0,
                idEstablecimiento: 0,
                idAlmacen: 0,
                tipoReporte: 1,
                ...FILTER
            },
            columnVisible: {
                tipo: 'hide',
                serie: 'hide',
                documento: 'hide',
                concepto: 'hide',
                fecha: 'hide',
                tipoCambio: 'hide',
                grupoConversionDolares: 'hide',
                subTotalConversionDolares: 'hide',
                igvConversionDolares: 'hide',
                totalConversionDolares: 'hide'
            },
            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idMoneda: 0,
            idEstablecimiento: 0,
            idAlmacen: 0,
            tipoReporte: 1,
            ...FILTER
        };
        this.setState({ filter, almacenes: [] });
        this._handlePagination(filter);
    };

    handleChange = async (property, value) => {

     const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };

        const { fechaInicioStr, fechaFinStr } = filter;

        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
            const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
            const fin = moment(fechaFinStr, 'DD/MM/YYYY');

            const meses = fin.diff(inicio, 'months', true);

            if (meses > MAX_MESES) {
                message.error('El rango máximo permitido es de 18 meses');
                return; // ⛔ no actualiza el estado
            }
        }

        this.setState({ filter: filter });
        if (property == 'idEstablecimiento') {
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            filter.idAlmacen = 0;

            this.setState({ almacenes, filter });
        } else {
            this.setState({ filter });
        }
    };

    handleExportExcel = async () => {
        this.setState({
            loadingExcel: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await compraEstablecimientoService.excel(this.state.filter);
            this.setState({ loadingExcel: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Compras por Establecimiento.xlsx");
        });
    };

    handleExportPdf = async () => {
        this.setState({
            loadingPdf: true,
            filter: {
                ...this.state.filter,
                flagRegistrado: false
            }
        }, async () => {
            var response = await compraEstablecimientoService.pdf(this.state.filter);
            this.setState({ loadingPdf: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Compras por Establecimiento.pdf");
        });

    };

    handleExportPdfRegistrado = async () => {
        this.setState({
            loadingPdfRegistrado: true,
            filter: {
                ...this.state.filter, flagRegistrado: true
            }
        }, async () => {
            var response = await compraEstablecimientoService.pdf(this.state.filter);
            this.setState({ loadingPdfRegistrado: false });
            if (response !== undefined)
                global.dowloadFile(response.data, "Reporte de Compras por Establecimiento (Registrados).pdf");
        });
    };

    handlePagination = () => {
        this._handlePagination(this.state.filter, () => {
            this.setState({
                columnVisible: {
                    ...this.state.columnVisible,
                    tipo: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    serie: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    documento: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    concepto: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',

                    fecha: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipoCambio: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',

                    grupoSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    subTotalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    igvConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    totalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',

                    grupoConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    subTotalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    igvConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    totalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide'
                },
            })
        });
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, compraEstablecimientoService.paginacion);
        var monedas = await monedaService.listar();
        const establecimientos = await establecimientoService.principales();

        if (monedas !== undefined)
            monedas.splice(0, 0, { id: '0', nombre: "MONEDA ORIGINAL" });

        this.setState({
            loadingSource: false,
            establecimientos: establecimientos ? establecimientos : [],
            monedas: monedas ? monedas : []
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Compras por Establecimiento"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    establecimientos={this.state.establecimientos}
                    monedas={this.state.monedas}
                    almacenes={this.state.almacenes}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    // onExportPdfRegistrado={this.handleExportPdfRegistrado}
                    onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}